var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('KSelect',_vm._g(_vm._b({attrs:{"items":_vm.termsOfDelivery,"return-object":false}},'KSelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }